import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { DensityProvider } from './context/DensityContext'
import { ErrorBoundary } from './components/ErrorBoundary'

import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <DensityProvider>
        <App />
      </DensityProvider>
    </ErrorBoundary>
  </StrictMode>,
)
